import type { DynamicClient, WalletAccount } from '@dynamic-labs-sdk/client';
import { getCore } from '@dynamic-labs-sdk/client/core';

import { PublicKeyNotFoundError } from '../../../errors/PublicKeyNotFoundError';

/**
 * Gets the public key for a wallet account from the user's verified credentials
 */
export const getPublicKeyForWalletAccount = (
  walletAccount: WalletAccount,
  client: DynamicClient
): string => {
  const user = getCore(client).state.get().user;

  for (const credential of user?.verifiedCredentials ?? []) {
    const additionalAddress = credential.walletAdditionalAddresses?.find(
      (addr) => addr.address === walletAccount.address
    );

    if (additionalAddress?.publicKey) {
      return additionalAddress.publicKey;
    }
  }

  throw new PublicKeyNotFoundError(walletAccount.address);
};
